import { getFallbackLocale } from "utils/locale";

const IS_IMPERSONATING = "isImpersonating";
const IS_PUPPETEER = "isPuppeteer";
const CLICKED_HINTS = "clickedHints";
const LOCALE = "locale";
const PORTFOLIO_IDS = "ls.lastPortfolioID";
const COMPANY_TYPE = "companyType";
const COMPANY_LIMITATIONS = "companyLimitations";
const USER_EMAIL = "ls.UserEmail";
const USER_TOKEN = "ls.UserToken";
const USER_ID = "ls.UserID";
const COMPANY_ID = "ls.CompanyID";
const DEALS_VIEW = "views.deal";

class DataStorage {
  static setSelectedPortfolioIDs(portfolioIDs) {
    localStorage.setItem(PORTFOLIO_IDS, portfolioIDs);
  }

  static getSelectedPortfolioIDs() {
    if (localStorage.getItem(PORTFOLIO_IDS)) {
      return localStorage
        .getItem(PORTFOLIO_IDS)
        .split(",")
        .map((p) => parseInt(p, 10));
    }

    return null;
  }

  static setCompanyType(type) {
    localStorage.setItem(COMPANY_TYPE, type);
  }

  static getCompanyType() {
    return DataStorage.getParsedValue(COMPANY_TYPE);
  }

  static setUserLocale(locale) {
    localStorage.setItem(LOCALE, locale);
  }

  static getUserLocale() {
    return DataStorage.getParsedValue(LOCALE);
  }

  static getClickedHints() {
    if (localStorage.getItem(CLICKED_HINTS)) {
      return localStorage.getItem(CLICKED_HINTS).split(",");
    }

    return [];
  }

  static setClickedHints(hints) {
    localStorage.setItem(CLICKED_HINTS, hints);
  }

  static setUserToken(userToken) {
    localStorage.setItem(USER_TOKEN, userToken);
  }

  static getUserToken() {
    return DataStorage.getParsedValue(USER_TOKEN);
  }

  static setUserID(userID) {
    localStorage.setItem(USER_ID, userID);
  }

  static getUserID() {
    return parseInt(DataStorage.getParsedValue(USER_ID) || 0, 10);
  }

  static setCompanyID(companyID) {
    localStorage.setItem(COMPANY_ID, companyID);
  }

  static getCompanyID() {
    return parseInt(DataStorage.getParsedValue(COMPANY_ID) || 0, 10);
  }

  static getCompanyLimitations() {
    if (localStorage.getItem(COMPANY_LIMITATIONS)) {
      return localStorage.getItem(COMPANY_LIMITATIONS).split(",");
    }

    return [];
  }

  static setCompanyLimitations(limitations) {
    localStorage.setItem(COMPANY_LIMITATIONS, limitations);
  }

  static setUserEmail(userEmail) {
    localStorage.setItem(USER_EMAIL, userEmail);
  }

  static getUserEmail() {
    return DataStorage.getParsedValue(USER_EMAIL);
  }

  static isImpersonating() {
    return !!DataStorage.getParsedValue(IS_IMPERSONATING);
  }

  static setImpersonating(isImpersonating) {
    localStorage.setItem(IS_IMPERSONATING, isImpersonating);
  }

  static isLoggedIn() {
    return !!DataStorage.getParsedValue(USER_TOKEN);
  }

  static DealsView() {
    return localStorage.getItem(DEALS_VIEW) || "TABLE";
  }

  static setDealsView(view) {
    localStorage.setItem(DEALS_VIEW, view);
  }

  static isPuppeteer() {
    return !!DataStorage.getParsedValue(IS_PUPPETEER);
  }

  static clear() {
    const locale = this.getUserLocale();
    localStorage.clear();

    return this.setUserLocale(getFallbackLocale(locale));
  }

  static getParsedValue(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return localStorage.getItem(key);
    }
  }

  static initialize(user) {
    DataStorage.setUserLocale(user.locale);
    DataStorage.setUserEmail(user.email);
    DataStorage.setUserToken(user.authenticationToken);
    DataStorage.setUserID(user.id);

    if (user.company) {
      DataStorage.setCompanyID(user.company.id);
      DataStorage.setCompanyType(user.company.type);
      DataStorage.setCompanyLimitations(user.company.limitations);
    }
  }
}

export default DataStorage;
